/**
 * 뷰어 미리보기 공통 고정 설정
 * 미리보기에서는 불필요한 기능을 비활성화
 */
export const PREVIEW_FIXED_CONFIG = Object.freeze({
    UI_TEXT_LAYER_ENABLE: false,
    UI_ANNOTATION_LAYER_ENABLE: false,
    UI_BOTTOM_CONTROLS_AUTO_HIDE: false,
    UI_FUNC_PRINT_CLIENT_ENABLE: false,

    UI_FUNC_RIGHT_CLICK_ENABLE: false,
    UI_FUNC_SHORT_CUT_ENABLE: false,
    UI_OPEN_SCREEN_MODE: "BASIC",
    UI_OPEN_PANEL: false,
    UI_OPEN_SCALE_MODE: "WIDTH",

    UI_FUNC_ZOOM_ENABLE: false,
    UI_FUNC_PRINT_ENABLE: false,
    UI_FUNC_DOWNLOAD_ENABLE: false,
    UI_FUNC_FULL_SCREEN_ENABLE: false,
    UI_FUNC_ROTATE_ENABLE: false,
    UI_FUNC_SEARCH_ENABLE: false,
    UI_FUNC_FIND_ENABLE: false,
    UI_FUNC_BOOK_MODE_ENABLE: false,
    UI_PANEL_ENABLE: false,
    UI_FUNC_HIGH_CONTRAST_ENABLE: false,
});
